export { default as BrandSEO } from "./BrandSEO";
